import { Outlet, useLocation } from 'react-router-dom';
import { AppNavBar } from './navBar';
import { cn } from '@/lib/core';
import { useUIStore } from '@/lib/core/stores/useUIStore';

interface AppLayoutProps {
  mode?: 'default' | 'light';
}

export function AppLayout({ mode = 'default' }: AppLayoutProps) {
  const { pathname } = useLocation();
  const segment = pathname.replace(/^\/|\/$/g, '');
  const isLocaleRoot = segment === '' || /^[a-z]{2}(-[a-zA-Z]{2,4})?$/i.test(segment);
  const hideNavbar = useUIStore(state => state.hideNavbar);
  const mainClassName = useUIStore(state => state.mainClassName);
  const navStyleOverride = useUIStore(state => state.navStyleOverride);

  mode = navStyleOverride ?? (isLocaleRoot ? 'default' : 'light');

  return (
    <div
      className={cn(
        'relative flex min-h-dvh flex-col',
        mode == 'default' ? 'bg-jncquoi-neutral-1000' : 'bg-white'
      )}
    >
      <main className={cn('relative w-full flex-1', mainClassName)}>
        <Outlet />
      </main>
      {!hideNavbar && <AppNavBar navStyle={mode} />}
    </div>
  );
}
